// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GCMp","index":"styles_index__2mkMC"};